<mbs-modal [titleTextOverflow]="true">
  <ng-container modal-header>
    <span [innerHTML]="'shared:computers.authRequiredFor' | i18next: { param: computerName }"></span>
  </ng-container>

  <ng-container modal-body>
    <mbs-alert
      [type]="alertType.warning"
      [icon]="true"
      [class.mb-0]="!needUpgradeBackupAgent">
      <ng-container *ngIf="needUpgradeBackupAgent; else reAuthArea">
        <span [innerHTML]="'shared:computers.modals.reAuthInfoUpgradeMessage' | i18next: { param: computerName }"></span>
      </ng-container>
      <ng-template #reAuthArea>
        <ng-container *ngIf="reAuthRequired; else simpleAuthNotificationArea">
          {{ 'shared:computers.modals.reAuthInfoRequired' | i18next }}
        </ng-container>
        <ng-template #simpleAuthNotificationArea>
          {{ 'shared:computers.modals.reAuthInfoSimple' | i18next }}
        </ng-template>
      </ng-template>
      <a
        target="_blank"
        [helpLink]="'https://kb.msp360.com/kb10140'"
        [kbMode]="true">
        {{ 'shared:buttons.learnMore' | i18next }}
      </a>
    </mbs-alert>
    <ng-container *ngIf="needUpgradeBackupAgent">
      {{ 'shared:computers.modals.reAuthInfoUpgradeBody' | i18next }}
    </ng-container>
  </ng-container>
  <ng-container modalFooter>
    <ng-container *ngIf="!needUpgradeBackupAgent">
      <mbs-button
        type="primary"
        (click)="baseModal.save()">
        {{ 'shared:buttons.continue' | i18next }}
      </mbs-button>
    </ng-container>
    <mbs-button (click)="baseModal.close()">
      {{ needUpgradeBackupAgent ? ('shared:buttons.close' | i18next) : ('shared:buttons.cancel' | i18next) }}
    </mbs-button>
  </ng-container>
</mbs-modal>
